var _regeneratorRuntime = require("/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

function resolveDatafile(_x) {
  return _resolveDatafile.apply(this, arguments);
}

function _resolveDatafile() {
  _resolveDatafile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(sdkKey) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch("https://config.exp.vpsvc.com/datafiles/".concat(sdkKey, ".json"));

          case 2:
            res = _context.sent;

            if (!res.ok) {
              _context.next = 9;
              break;
            }

            _context.next = 6;
            return res.json();

          case 6:
            return _context.abrupt("return", _context.sent);

          case 9:
            throw new Error("Experiment impression not sent because datafile fetch failed: ".concat(res.status));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _resolveDatafile.apply(this, arguments);
}

exports.resolveDatafile = resolveDatafile;